export default __webpack_public_path__ + "static/media/orientation_core.b3f08d34.pdf";